export const iconFontAwesomeSportsFitnessGolfBallTee = (
	<i className="fa-solid fa-golf-ball-tee"></i>
);
